import { render, staticRenderFns } from "./ManageEmailPreferences.vue?vue&type=template&id=3f27ae5e&"
import script from "./ManageEmailPreferences.vue?vue&type=script&lang=js&"
export * from "./ManageEmailPreferences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports